:host {
  display: block;
}

.tooltip:hover .tooltip-item {
  visibility: visible;
}

.banner-msm-title-width {
  @apply hover:bg-blue-500 whitespace-nowrap overflow-hidden text-ellipsis font-extrabold text-xl leading-6;
}

.banner-msm-tooltip-width {
  @apply flex p-2 text-base text-left bg-white text-blue-600 rounded z-20 absolute invisible tooltip-item border border-solid border-clrs-argo-blue;
}